import CreationToolUserRestriction from './user-restriction'

/**
 * section available for new Super Cut captures.
 */
enum CreationToolSuperCutSection {
    Capture = 'CT_SUPER_CUT_FIELD_CAPTURE_TITLE',
    Advanced = 'CT_SUPER_CUT_FIELD_WATERMARK',
    Metadata = 'CT_SUPER_CUT_FIELD_WATERMARK_FILE',
}

namespace CreationToolSuperCutSection {
    /**
     * Returns all sections (in order).
     */
    export function all(): CreationToolSuperCutSection[] {
        return [
            CreationToolSuperCutSection.Capture,
            CreationToolSuperCutSection.Advanced,
            CreationToolSuperCutSection.Metadata,
        ]
    }

    /**
     * Returns the sections's title.
     */
    export function title(section: CreationToolSuperCutSection): string {
        switch (section) {
            case CreationToolSuperCutSection.Capture:
                return 'Capture'
            case CreationToolSuperCutSection.Advanced:
                return 'Advanced'
            case CreationToolSuperCutSection.Metadata:
                return 'Metadata'
        }
    }

    export function isEditable(section: CreationToolSuperCutSection, isEditMode?: boolean): boolean {
        switch (section) {
            case CreationToolSuperCutSection.Advanced:
                return !isEditMode
            default:
                return true
        }
    }

    /**
     * Returns a user restriction for the section.
     */
    export function userRestriction(section: CreationToolSuperCutSection): CreationToolUserRestriction {
        switch (section) {
            default:
                return CreationToolUserRestriction.Everyone
        }
    }
}

export default CreationToolSuperCutSection
